(() => {
 'use strict';
 let modelPromise;
 const embeddings=new Map();
 async function embed(texts,status) {
   if (!modelPromise) modelPromise=(async()=>{
     status('Loading AI matching for the first time. This may take a moment…');
     const {pipeline,env}=await import('https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.8.1');
     env.allowLocalModels=false;
     env.backends.onnx.wasm.numThreads=1;
     env.backends.onnx.wasm.proxy=false;
     return pipeline('feature-extraction','Xenova/all-MiniLM-L6-v2',{dtype:'q8',device:'wasm'});
   })().catch(e=>{modelPromise=null;throw e;});
   const pipe=await modelPromise;
   const missing=[...new Set(texts.filter(t=>!embeddings.has(t)))];
   for(let i=0;i<missing.length;i+=8){
     status('AI is comparing your request with games and use cases…');
     const batch=missing.slice(i,i+8);
     const vectors=(await pipe(batch,{pooling:'mean',normalize:true})).tolist();
     batch.forEach((t,j)=>embeddings.set(t,vectors[j]));
   }
   return texts.map(t=>embeddings.get(t));
 }
 const dot=(a,b)=>a.reduce((s,v,i)=>s+v*b[i],0);
 const el=(tag,text,cls)=>{const n=document.createElement(tag);if(text)n.textContent=text;if(cls)n.className=cls;return n;};
 const money=n=>new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'}).format(n);
 const read=(root,selector,fallback)=>{try{return JSON.parse(root.querySelector(selector)?.textContent||JSON.stringify(fallback));}catch{return fallback;}};
 function start(root=document) {
   const scope=root.querySelector('.gc-discovery');
   if(!scope||scope.dataset.bound)return;
   scope.dataset.bound='true';
   const core=globalThis.GroovyFinderCore,form=scope.querySelector('form'),f=form.elements;
   const games=read(document,'[data-gc-games]',[]),catalog=read(document,'[data-gc-finder-catalog]',[]);
   const records=read(document,'[data-gc-benchmarks]',[]);
   const output=scope.querySelector('[data-discovery-results]'),status=scope.querySelector('[data-discovery-status]');
   const summary=scope.querySelector('[data-results-summary]'),heading=scope.querySelector('[data-results-heading]');
   const submit=form.querySelector('[type=submit]');
   let mode='pc',run=0,lastParsedRequest='',inferredUse='gaming',lastRankedGames=games;
   const setStatus=t=>status.textContent=t;
   games.forEach(g=>{if(g.id==='gta6')return;const o=el('option',g.title);o.value=g.id;f.game.append(o);});
   const noGame=el('option','No specific game / work and creativity');noGame.value='none';f.game.append(noGame);
   const game=()=>games.find(g=>g.id===f.game.value);
   const picture=(src,alt,gameArt=false)=>{
     const frame=el('div',null,gameArt?'gc-game-art':'gc-match-image'),img=el('img');
     img.src=src;img.alt=alt;img.width=900;img.height=gameArt?421:900;img.loading='lazy';img.decoding='async';
     img.addEventListener('error',()=>{frame.replaceChildren(el('p','Photo unavailable — open the listing to view its gallery.'));},{once:true});
     frame.append(img);return frame;
   };
   function target() {
     const g=game(),source=scope.querySelector('[data-target-source]');
     scope.querySelector('[data-target-title]').textContent=g?.id==='gta6'?'Inspired by GTA VI':g?`${g.title} · your next adventure`:'Your ideas. Your next setup.';
     scope.querySelector('.gc-target-monogram').textContent=g?.id==='gta6'?'VI':g?'▶':'↗';
     scope.querySelector('[data-target-note]').textContent=g?.id==='gta6'?'Love the neon nights and open-world atmosphere? Make that energy part of your setup. Explore our current gaming PCs by budget and graphics preference.':g?'One more mission. One more night with your crew. Explore a setup around the way you love to play.':'From the first idea to the finished project, find a setup for the work you love creating.';
     source.href=g?.url||'/pages/contact';source.textContent=g?'Official game information ↗':'Discuss your software with Groovy ↗';
   }
   function card(p,use) {
     const a=el('article',null,'gc-match-card');a.append(picture(p.image,p.productTitle));
     const body=el('div',null,'gc-match-body');
     body.append(el('p','AVAILABLE CONFIGURATION','gta-kicker'),el('h4',p.productTitle.split('|')[0].split(',')[0].trim()));
     body.append(el('p',p.title==='Default Title'?(p.gpu||'See complete specifications'):p.title,'gc-match-specs'));
     body.append(el('p',`${use.name} collection · within your ${money(Number(f.budget.value))} budget`,'gc-match-reason'));
     const price=el('strong',money(p.price)+' CAD','gc-match-price');body.append(price);
     const g=game(),bench=core.benchmark(records,p.id,g?.id,f.preset.value);
     if(g&&use.id!=='parts'&&bench&&bench.kind!=='estimate'){
       const performance=el('div',null,'gc-match-performance');
       performance.append(el('span',`${g.title} [${f.preset.value}]`));
       if(bench){
         performance.append(el('strong',`${bench.fps} FPS · ${bench.kind==='estimate'?'estimate':'measured'}`),el('small',`${bench.rendering} · ${bench.testedAt}`));
         const link=el('a','View benchmark ↗');link.href=bench.source;link.target='_blank';link.rel='noopener';performance.append(link);
       }
       body.append(performance);
     }
     const link=el('a','See this configuration ↗','gc-match-link');link.href=p.url;body.append(link);
     a.append(body);return a;
   }
   function pcResults(purpose,constraints={}) {
     const use=core.uses.find(u=>u.id===purpose)||core.uses[0];
     const matches=core.select(catalog,{budget:Number(f.budget.value),purpose:use.id,preset:f.preset.value,constraints});
     heading.textContent=use.id==='parts'?'Your next upgrade starts here':'Meet your next setup';
     summary.textContent=`${use.name} · up to ${money(Number(f.budget.value))} CAD${constraints.gpu?' · '+constraints.gpu:''}${constraints.ram?' · at least '+constraints.ram+'GB RAM':''}`;
     output.replaceChildren(...matches.map(p=>card(p,use)));
     if(!matches.length){
       const empty=el('div',null,'gc-discovery-empty');
       empty.append(el('h4','Let’s find your fit'),el('p','Explore more configurations or tell Groovy what matters most. We’ll help you find your next setup.'));
       const a=el('a','Browse the full collection ↗');a.href='/collections/'+use.groups[0];empty.append(a);output.append(empty);
     }
   }
   function gameResults(ranked) {
     heading.textContent='Find your next game';
     summary.textContent='Curated picks from official game pages · game purchases are separate from your PC.';
     let choices=ranked.filter(g=>f.era.value==='all'||g.era===f.era.value);
     if(!f.request.value.trim()&&f.era.value==='all')choices=[games[0],...choices.filter(g=>g.id!=='gta6')];
     output.replaceChildren(...choices.slice(0,6).map(g=>{
       const a=el('article',null,'gc-game-card');
       if(g.image)a.append(picture(g.image,g.title+' official game artwork',true));
       else{const art=el('div',null,'gc-game-art gc-game-vi');art.append(el('strong','VI'),el('span','GRAND THEFT AUTO'));a.append(art);}
       const b=el('div',null,'gc-match-body');b.append(el('p',g.era.toUpperCase(),'gta-kicker'),el('h4',g.title),el('p',g.summary));
       const choose=el('button',g.id==='gta6'?'Explore gaming setups ↗':'Explore gaming PCs ↗','gc-match-link');choose.type='button';
       choose.addEventListener('click',()=>{f.game.value=g.id;f.request.value='';f.purpose.value='gaming';switchMode('pc');pcResults('gaming');setStatus('Guided shortlist. Your game selection is saved.');scope.querySelector('[data-target-title]').scrollIntoView({behavior:'smooth',block:'center'});});
       const link=el('a','Game details & requirements ↗');link.href=g.url;link.target='_blank';link.rel='noopener';
       b.append(choose,link);a.append(b);return a;
     }));
   }
   function chips() {
     const labels=mode==='pc'?['1440p gaming under $2,500','Streaming and recording','4K video editing with 32GB RAM']:['A relaxing game after work','A co-op game with friends','An older story-driven adventure'];
     scope.querySelector('[data-query-chips]').replaceChildren(...labels.map(t=>{const b=el('button',t);b.type='button';b.addEventListener('click',()=>{f.request.value=t;f.request.focus();});return b;}));
   }
   function switchMode(next) {
     ++run;mode=next;submit.disabled=false;scope.dataset.mode=mode;
     scope.querySelectorAll('[data-discovery-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.discoveryMode===mode)));
     scope.querySelector('[data-pc-controls]').hidden=mode!=='pc';scope.querySelector('[data-game-controls]').hidden=mode!=='games';
     f.budget.required=mode==='pc';
     f.request.placeholder=mode==='pc'?'A PC for open-world games at 1440p, streaming and some video editing…':'Something like GTA, a co-op adventure with friends, or a classic I missed…';
     scope.querySelector('[data-discovery-footnote]').textContent=mode==='pc'?'Prices in CAD, before tax and shipping. Availability is checked when this page loads. Review the exact configuration before checkout.':'A curated game library, reviewed October 20, 2026. “Popular picks” is an editorial selection, not a live sales chart. Check age ratings and requirements on the official pages.';
     chips();target();mode==='pc'?pcResults(f.purpose.value==='auto'?inferredUse:f.purpose.value):gameResults(games);
   }
   async function search(ai) {
     if(!form.reportValidity())return;
     const token=++run,text=f.request.value.trim(),parsed=core.interpret(text);
     const update=t=>{if(token===run)setStatus(t);};
     if(mode==='pc'&&text!==lastParsedRequest){
       if(parsed.budget)f.budget.value=parsed.budget;
       if(parsed.res||parsed.quality){
         const [r,q]=f.preset.value.split(' '),candidate=`${parsed.res||r} ${parsed.quality||q}`;
         if([...f.preset.options].some(o=>o.value===candidate))f.preset.value=candidate;
       }
       const exact=games.filter(g=>text.toLowerCase().includes(g.title.toLowerCase())||(g.id==='gta6'&&/\bgta\s*(6|vi)\b/i.test(text)));
       if(exact.length)f.game.value=exact[0].id;
       lastParsedRequest=text;target();
     }
     let use=f.purpose.value==='auto'?inferredUse:f.purpose.value;
     let ranked=games;
     submit.disabled=true;
     try{
       if(ai&&text){
         const descriptions=mode==='games'?games.map(g=>`${g.title}. ${g.summary} ${g.tags}`):core.uses.map(u=>u.text);
         const vectors=await embed([text,...descriptions],update);if(token!==run)return;
         const scores=descriptions.map((_,i)=>({i,score:dot(vectors[0],vectors[i+1])})).sort((a,b)=>b.score-a.score);
         if(mode==='games')ranked=scores.map(s=>games[s.i]);
         else if(f.purpose.value==='auto')use=core.uses[scores[0].i].id;
         update('AI-assisted matches ready. Adjust the filters to refine your selection.');
       }else {
         if(text){
           if(mode==='games')ranked=[...games].sort((a,b)=>core.overlap(text,b.tags+' '+b.summary)-core.overlap(text,a.tags+' '+a.summary));
           else if(f.purpose.value==='auto')use=[...core.uses].sort((a,b)=>core.overlap(text,b.text)-core.overlap(text,a.text))[0].id;
         }
         update('Guided matches ready. Add a request and search to use AI-assisted matching.');
       }
       if(token!==run)return;
       if(mode==='games'){lastRankedGames=ranked;gameResults(ranked);}else{inferredUse=use;pcResults(use,parsed);}
     }catch(e){
       if(token!==run)return;
       update('AI could not load on this connection. Guided results are shown; try the search again to retry AI.');
       mode==='games'?gameResults(games):pcResults(use,parsed);
     }finally{if(token===run)submit.disabled=false;}
   }
   form.addEventListener('submit',e=>{e.preventDefault();search(true);});
   scope.querySelector('[data-guided]').addEventListener('click',()=>search(false));
   scope.querySelectorAll('[data-discovery-mode]').forEach(b=>b.addEventListener('click',()=>switchMode(b.dataset.discoveryMode)));
   ['game','preset','purpose','budget','era'].forEach(name=>f[name].addEventListener('change',()=>{++run;submit.disabled=false;target();if(mode==='games')gameResults(lastRankedGames);else if(form.reportValidity())pcResults(f.purpose.value==='auto'?inferredUse:f.purpose.value,core.interpret(f.request.value));setStatus('Filters updated. Search again if you change your request.');}));
   switchMode('pc');
 }
 document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>start()):start();
 document.addEventListener('shopify:section:load',e=>start(e.target));
})();
